import { HTMLAttributes } from 'react';
import cls from 'classnames';

import Icon from '@/common/components/Icon/Icon';
import Label, { SIZE_LARGE, SIZE_MEDIUM } from '@/common/components/Label/Label';
import { GlobalAccessLevel } from '@/security/constants/GlobalAccessLevel';
import { AccessTargetType } from '@/security/types/AccessTarget';
import { DataAccess } from '@/security/types/DataAccess';

import { getAccessLabelAppearance, getAccessLabelIcon, getDriveAccessAppearance } from '../../constants/access';
import { getDataAccessIcon } from '../../constants/dataAccess';

import styles from './AccessLabel.module.css';

interface AccessLabelProps extends HTMLAttributes<HTMLSpanElement> {
  type: AccessTargetType;
  access: GlobalAccessLevel;
  dataAccess?: DataAccess;
  size?: typeof SIZE_MEDIUM | typeof SIZE_LARGE;
  isFullWidth?: boolean;
}

function AccessLabel(props: AccessLabelProps) {
  const { access, dataAccess, size, type, isFullWidth, ...rest } = props;

  const isDataAccessPassed = typeof dataAccess !== 'undefined';

  const accessAppearance =
    type === 'driveFolder' || type === 'collection'
      ? getDriveAccessAppearance(access)
      : getAccessLabelAppearance(access);

  return (
    <Label
      appearance={accessAppearance}
      block={isFullWidth}
      className={cls(styles.root, { [styles.fullWidth]: isFullWidth })}
      size={size}
      {...rest}
    >
      <Icon name={getAccessLabelIcon(access)} />

      {isDataAccessPassed && access !== GlobalAccessLevel.Restricted && (
        <Icon name={getDataAccessIcon(dataAccess, type)} />
      )}
    </Label>
  );
}

export default AccessLabel;
